import { parseJwt, PartnerJwt } from '@jurnee/common/src/utils/auth';
import { RootState } from 'store';

export function getIsAuthenticatedSelector({ auth }: RootState) {
  return auth.status === 'AUTHENTICATED';
}

export function getIsPartnerUserSelector({ auth }: RootState) {
  if (auth.status !== 'AUTHENTICATED' || !auth.token) {
    return false;
  }

  const tokenType = parseJwt<PartnerJwt>(auth.token).type;
  return tokenType === 'PARTNER_USER_ACCESS_TOKEN';
}